import { Controller } from '@hotwired/stimulus';
import Rails from '@rails/ujs';

export default class extends Controller {
  submit() {
    this._submitForm();
  }

  _submitForm() {
    const formData = new FormData(this.element);

    Rails.ajax({
      url: this.element.action,
      type: 'POST',
      data: formData,
      success: () => {
        this._reloadPage();
      }
    });
  }

  _reloadPage() {
    window.location.reload();
  }
}
